import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from './Input/Input';
import 'whatwg-fetch';
import { sendResetPasswordEmail } from '../api/authentication';

const ForgotPassword = () => {
  const [username, setUserName] = useState('');
  const [passwordText, setPasswordText] = useState('');
  const navigate = useNavigate();

  async function handleSubmit(event) {
    event.preventDefault();
    try {
      const data = await sendResetPasswordEmail(event.target);
      if (data.email === 'Invalid') {
        setPasswordText('Please check your email address');
        setUserName('');
      }
      if (data.email === 'Password reset email sent.') {
        navigate('/passwordResetSent');
      }
      if (data.email === 'Password was changed only recently.') {
        setPasswordText(data.email);
      }
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="full-width-container ">
      <div className="floating-box login-container">
        <h1 className="floating-box-header">
          <span>Reset Password</span>
        </h1>
        <div className="sub-heading">
          Enter your registered email address in the field below, then check your email inbox (including spam
          folders).{' '}
        </div>
        <div className="sub-heading password-error2">{passwordText}</div>
        <form onSubmit={handleSubmit} className="d-flex flex-column p-3">
          <Input
            name="username"
            className=""
            type="text"
            label="Username"
            value={username}
            onChange={(e) => setUserName(e.target.value)}
            required
          />
          <div className="d-flex flex-row justify-content-between">
            <button type="submit" className="blue-button">
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
